import React from "react";

export default function Footer() {
  return (
    <div className="flex flex-col items-center">
      <div className="flex flex-col bg-white items-center">
        <img src="/icons/footer/footer1.png"></img>
        <img src="/icons/footer/Layer2.png"></img>
      </div>
      <div
        style={{ backgroundImage: "url('/icons/footer/bg1.png')" }}
        className="h-[362px] w-[1440px] bg-no-repeat flex pl-[135px] pt-[18px]    "
      >
        <div className="flex flex-col mt-9 items-center ">
          <img src="/icons/footer/spiral300.png"></img>
          <div className="flex gap-1 ">
            <a
              href="https://www.facebook.com/spiralproductionservice"
              target="_blank"
            >
              <img
                className="mt-6 cursor-pointer"
                src="/icons/footer/facebook.png"
                alt="Facebook"
              ></img>
            </a>
            <a
              href="https://www.linkedin.com/company/spiral-company"
              target="_blank"
            >
              <img
                className="mt-6 cursor-pointer"
                src="/icons/footer/linkedin.png"
                alt="LinkedIn"
              ></img>
            </a>
            <a href="https://www.youtube.com" target="_blank">
              <img
                className="mt-6 cursor-pointer"
                src="/icons/footer/youtube.png"
                alt="YouTube"
              ></img>
            </a>
            <a href="https://www.tiktok.com/@timviecspiral" target="_blank">
              <img
                className="mt-6 cursor-pointer"
                src="/icons/footer/tiktok.png"
                alt="TikTok"
              ></img>
            </a>
          </div>
          <h3 className="font-normal text-[14px]">Copyright © Spiral 2024</h3>
        </div>
        <div className="flex flex-col ml-48 mt-0 text-right ">
          <h3 className="font-normal text-[16px] text-[#282828]">CONTACT US</h3>
          <h3 className="font-bold text-[25px] text-[#0B0B0B]">
            CUSTOMER SERVICE
          </h3>
          <h3 className="mt-3 flex items-center  justify-end font-normal text-[16px] text-[#000000]">
            <img src="/icons/footer/loc.svg" className="inline "></img>
            <span className="indent-2">{"  "}72 Le Thanh Ton Street,</span>
          </h3>
          <h3 className="  font-inter font-normal text-[16px] text-[#000000]">
            Ben Nghe Ward, District 1, HCMC
          </h3>
          <h3 className="mt-3 font-bold text-[16px] text-[#0B0B0B]">
            FIELD MARKETING OUTSOURCING SOLUTIONS
          </h3>
          <h3 className="flex items-center justify-end font-bold text-[14px] text-[#000000]">
            <img src="/icons/footer/phone.svg" className="inline "></img>
            <span className="indent-2"> +84(028) 730 88080</span>
          </h3>
          <h3 className="flex items-center  justify-end  font-normal text-[16px] text-[#000000]">
            <img src="/icons/footer/email.svg" className="  inline "></img>
            <span className="indent-2">contact@spiral.com.vn</span>
          </h3>
          <h3 className="mt-3 font-bold text-[16px] text-[#0B0B0B]">
            PRODUCTION OUTSOURCING SOLUTIONS
          </h3>
          <h3 className="flex items-center justify-end font-bold text-[14px] text-[#000000]">
            <img src="/icons/footer/phone.svg" className="inline "></img>
                      <span className="indent-2 mt-1"> (+84) 911 386 060 {" "}</span>
          </h3>
          <h3 className="flex items-center  justify-end  font-normal text-[16px] text-[#000000]">
            <img src="/icons/footer/email.svg" className="  inline "></img>
                      <span className="indent-2">production.service@spiral.com.vn</span>
          </h3>
          {/* Thoem moi */}
          <h3 className="flex items-center justify-end font-bold text-[14px] text-[#000000]">
            <img src="/icons/footer/phone.svg" className="inline "></img>
                      <span className="indent-2 mt-1"> (+84) 941 351 313 (Mr. Vũ)</span>
          </h3>
          <h3 className="flex items-center  justify-end  font-normal text-[16px] text-[#000000]">
            <img src="/icons/footer/email.svg" className="  inline "></img>
                      <span className="indent-2">vunguyen@spiral.com.vn</span>
          </h3>
        </div>
      </div>
    </div>
  );
}
